module.exports = __webpack_public_path__ + "img/HEB_ONLINE.77c777de.png";